<template>
  <div class="pcenter" style="margin-top: 20px; flex-wrap: wrap;">
    <div class="pcenter" style="padding: 10px;">
      <div style="border: 1px #ccc solid; padding: 20px; flex-flow: column;">
        <div class="pcenter" @click="buymodeltmp(gid)">
          <img style="width:120px;height:120px;" :src="gimg" />
          <div class="pcenter" style="flex-flow: column;align-items: flex-start; padding-left: 10px;">
            <span style="font-size:16px;min-width: 160px;">{{gname}}</span>
            <span style="margin-top: 10px;font-size: 12px;color: #ccc;">{{gdes}}</span>
            <div style="display:flex; margin-top: 10px; width:100%;">
              <span style="color: darkgreen; flex:1;">￥{{price}}元/月</span>
            </div>
          </div>
        </div>
        <div style="margin-top: 10px; margin-left: 20px; font-size: 12px;">
              <span style="color: darkgreen;" v-if="gbuystate == 1">状态（已购买）有效期至：{{gbuytime}}
                <div style="display: flex;" v-if="gid==1">
                  <span style="flex: 1">微店地址： {{gopath}} </span>
                  <el-tooltip class="item" effect="dark" content="下载二维码" placement="top-start">
                    <i style="margin-left: 30px; width:20px;" class="fa el-icon-menu gtopicon" v-on:click="dbarcode(gopath)"></i>
                  </el-tooltip>
                </div>
              </span>
          <span style="color: #ccc;" v-else>状态（未购买）</span>
        </div>
      </div>
    </div>
    <el-dialog title="二维码信息" :visible.sync="qrcodevisible">
      <BarDownLoad ref="bdl"></BarDownLoad>
    </el-dialog>
  </div>
</template>

<script>
  import BarDownLoad from '../model/BarDownLoad'
  var that
  export default {
    name: 'GoodsListTemp',
    components:{ BarDownLoad },
    props: {
      gid: Number,
      gimg:String,
      gname:String,
      gdes:String,
      price:String,
      gbuystate: Number,
      gbuytime: String
    },
    data () {
      return {
        gopath: '',
        qrcodevisible: false,
        buymodeltmp (tmpid) {
          this.$emit('buymodelonlist',tmpid);
        }
      }
    },
    mounted () {
      that = this
      that.gopath = 'http://ecomm.sqnetsoft.cn/ecomm/#/?cusid=' + localStorage.getItem('cusid')
    },
    methods: {
      dbarcode (url) {
        this.qrcodevisible = true
        setTimeout(() => {
          this.$refs.bdl.getcode(url)
        },0)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ecomm/GoodsListTemp.vue